import { createSlice, PayloadAction } from '@reduxjs/toolkit';
/* eslint-disable  import/no-cycle */
import { RootState } from 'store/rootReducer';

const initialState: { appMenuOpen: boolean } = {
  appMenuOpen: false
};

const productsSlice = createSlice({
  initialState,
  name: 'appMenu',
  reducers: {
    setAppMenuOpen: (state, { payload }: PayloadAction<boolean>) => {
      state.appMenuOpen = payload;
    }
  }
});

const { actions, reducer } = productsSlice;
export { reducer as appMenu };
export const { setAppMenuOpen } = actions;

export const isAppMenuOpen = (state: RootState) => state.appMenu.appMenuOpen;
